import { Outlet } from "react-router-dom";

import { useGetAuthUser } from "@/api/get-user";
import { Logo } from "@/components/logo";
import { LogoutNavigationItem } from "@/components/logout-navigation-item";
import { Version } from "@/components/version";
import { ExistingAccount } from "@/features/registration/components/existing-account";
import { OnboardingMobileNavigation } from "@/features/registration/components/onboarding-mobile-navigation";
import { OnboardingNavigation } from "@/features/registration/components/onboarding-navigation";

export default function OnboardingLayout() {
  const { data: user } = useGetAuthUser();

  return (
    <>
      {/* Static sidebar for desktop */}
      <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-96 lg:flex-col 2xl:w-[440px]">
        {/* Sidebar component, swap this element with another sidebar if you like */}
        <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-card px-6 pb-4">
          <div className="flex h-16 shrink-0 items-center">
            <Logo />
          </div>
          <OnboardingNavigation />
          <div className="mt-auto">
            {user ? <LogoutNavigationItem /> : <ExistingAccount />}
          </div>
        </div>
      </div>

      <div className="relative h-full lg:pl-96 lg:pt-2 2xl:pl-[440px]">
        <div className="flex min-h-full flex-col overflow-hidden border-border bg-background bg-dotted bg-right-top bg-no-repeat lg:rounded-tl-lg lg:border-l-2 lg:border-t-2">
          <OnboardingMobileNavigation />
          <main className="pb-6 pt-6 lg:pt-20 2xl:pt-24">
            <div className="max-w-2xl px-4 sm:px-6 lg:px-8">
              <Outlet />
            </div>
          </main>
          <Version className="mt-auto" />
        </div>
      </div>
    </>
  );
}
